/* eslint-disable prefer-rest-params */
/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable radix */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/prefer-es6-class */
/* eslint-disable no-underscore-dangle */
/* eslint-disable operator-assignment */
/* eslint-disable sonarjs/cognitive-complexity */
/* @ts-nocheck */
import createReactClass from 'create-react-class';
import React from 'react';
import ReactDom from 'react-dom';

/**
 * To enable React 19 migration, this file was 'forked' locally from the Reorder libarby.
 * The Reorder library is unmaintened and legacy code incompatible with React 19
 * The changes from the original repo are:
 * - Replace the findDomNode with an id + window.document.getElementById
 * - Remove the PropTypes
 *
 */

const CONSTANTS = {
  HOLD_THRESHOLD: 8,
  SCROLL_INTERVAL: 1000 / 60,
  SCROLL_AREA_MAX: 50,
  SCROLL_SPEED: 20,
};

let downPos = null;
let mouseOffset = null;
let mouseDown = null;

function createOffsetStyles(event, props) {
  const top =
    !props.lock || props.lock === 'horizontal'
      ? mouseOffset.clientY - mouseDown.clientY
      : 0;
  const left =
    !props.lock || props.lock === 'vertical'
      ? mouseOffset.clientX - mouseDown.clientX
      : 0;

  return `translate(${left}px,${top}px)`;
}

function getScrollOffsetX(rect, node) {
  let positionInScrollArea;
  const scrollLeft = node.scrollLeft;
  const scrollWidth = node.scrollWidth;

  const scrollAreaX = Math.min(rect.width / 3, CONSTANTS.SCROLL_AREA_MAX);

  if (scrollLeft > 0 && mouseOffset.clientX <= rect.left + scrollAreaX) {
    positionInScrollArea = Math.min(
      Math.abs(rect.left + scrollAreaX - mouseOffset.clientX),
      scrollAreaX,
    );
    return (-positionInScrollArea / scrollAreaX) * CONSTANTS.SCROLL_SPEED;
  }

  if (
    scrollLeft < scrollWidth - rect.width &&
    mouseOffset.clientX >= rect.right - scrollAreaX
  ) {
    positionInScrollArea = Math.min(
      Math.abs(rect.right - scrollAreaX - mouseOffset.clientX),
      scrollAreaX,
    );
    return (positionInScrollArea / scrollAreaX) * CONSTANTS.SCROLL_SPEED;
  }

  return 0;
}

function getScrollOffsetY(rect, node) {
  let positionInScrollArea;
  const scrollTop = node.scrollTop;
  const scrollHeight = node.scrollHeight;

  const scrollAreaY = Math.min(rect.height / 3, CONSTANTS.SCROLL_AREA_MAX);

  if (scrollTop > 0 && mouseOffset.clientY <= rect.top + scrollAreaY) {
    positionInScrollArea = Math.min(
      Math.abs(rect.top + scrollAreaY - mouseOffset.clientY),
      scrollAreaY,
    );
    return (-positionInScrollArea / scrollAreaY) * CONSTANTS.SCROLL_SPEED;
  }

  if (
    scrollTop < scrollHeight - rect.height &&
    mouseOffset.clientY >= rect.bottom - scrollAreaY
  ) {
    positionInScrollArea = Math.min(
      Math.abs(rect.bottom - scrollAreaY - mouseOffset.clientY),
      scrollAreaY,
    );
    return (positionInScrollArea / scrollAreaY) * CONSTANTS.SCROLL_SPEED;
  }

  return 0;
}

function scrollParentsX(node) {
  let parent = node.parentNode;

  while (parent && parent !== document) {
    const rect = parent.getBoundingClientRect();

    const scrollOffsetX = getScrollOffsetX(rect, parent);

    if (!scrollOffsetX) {
      scrollParentsX(parent);
    } else if (scrollOffsetX) {
      parent.scrollLeft += scrollOffsetX;
      return;
    }

    parent = parent.parentNode;
  }
}

function scrollParentsY(node) {
  let parent = node.parentNode;

  while (parent && parent !== document) {
    const rect = parent.getBoundingClientRect();

    const scrollOffsetY = getScrollOffsetY(rect, parent);

    if (!scrollOffsetY) {
      scrollParentsX(parent);
    } else if (scrollOffsetY) {
      parent.scrollTop += scrollOffsetY;
      return;
    }

    parent = parent.parentNode;
  }
}

function Store() {
  let activeGroup = null;
  let draggedId = null;
  let placedId = null;
  let draggedElement = null;
  let scrollInterval = null;
  let target = null;

  let draggedStyle = null;
  let draggedIndex = -1;
  let placedIndex = -1;

  const reorderComponents = {};
  const reorderGroups = {};

  function autoScroll() {
    if (target && target.props.autoScroll && target.rootNode) {
      const rect = target.rootNode.getBoundingClientRect();

      if (target.props.lock !== 'horizontal') {
        const scrollOffsetX = getScrollOffsetX(rect, target.rootNode);

        if (target.props.autoScrollParents && !scrollOffsetX) {
          scrollParentsX(target.rootNode);
        } else if (scrollOffsetX) {
          target.rootNode.scrollLeft =
            target.rootNode.scrollLeft + scrollOffsetX;
        }
      }

      if (target.props.lock !== 'vertical') {
        const scrollOffsetY = getScrollOffsetY(rect, target.rootNode);

        if (target.props.autoScrollParents && !scrollOffsetY) {
          scrollParentsY(target.rootNode);
        } else if (scrollOffsetY) {
          target.rootNode.scrollTop = target.rootNode.scrollTop + scrollOffsetY;
        }
      }
    }
  }

  function getState() {
    return {
      draggedId,
      placedId,
      activeGroup,
      draggedStyle,
      draggedIndex,
      placedIndex,
      draggedElement,
    };
  }

  function trigger(clear) {
    const state = getState();

    if (clear) {
      for (const element of clear) {
        state[element] = null;
      }
    }

    reorderComponents[draggedId].setDragState(state);
  }

  function triggerGroup(clear) {
    const state = getState();

    if (clear) {
      for (const element of clear) {
        state[element] = null;
      }
    }

    for (const reorderId in reorderGroups[activeGroup]) {
      reorderGroups[activeGroup][reorderId].setDragState(state);
    }
  }

  function validateComponentIdAndGroup(reorderId, reorderGroup) {
    if (typeof reorderId !== 'string') {
      throw new Error(
        `Expected reorderId to be a string. Instead got ${typeof reorderId}`,
      );
    }

    if (
      typeof reorderGroup !== 'undefined' &&
      typeof reorderGroup !== 'string'
    ) {
      throw new Error(
        `Expected reorderGroup to be a string. Instead got ${typeof reorderGroup}`,
      );
    }
  }

  function registerReorderComponent(component) {
    const reorderId = component.props.reorderId;
    const reorderGroup = component.props.reorderGroup;

    validateComponentIdAndGroup(reorderId, reorderGroup);

    if (typeof reorderGroup !== 'undefined') {
      if (
        reorderGroup in reorderGroups &&
        reorderId in reorderGroups[reorderGroup]
      ) {
        throw new Error(
          `Duplicate reorderId: ${reorderId} in reorderGroup: ${reorderGroup}`,
        );
      }

      reorderGroups[reorderGroup] = reorderGroups[reorderGroup] || {};
      reorderGroups[reorderGroup][reorderId] = component;
    } else {
      if (reorderId in reorderComponents) {
        throw new Error(`Duplicate reorderId: ${reorderId}`);
      }

      reorderComponents[reorderId] = component;
    }
  }

  function unregisterReorderComponent(component) {
    const reorderId = component.props.reorderId;
    const reorderGroup = component.props.reorderGroup;

    validateComponentIdAndGroup(reorderId, reorderGroup);

    if (typeof reorderGroup !== 'undefined') {
      if (!(reorderGroup in reorderGroups)) {
        throw new Error(`Unknown reorderGroup: ${reorderGroup}`);
      }

      if (
        reorderGroup in reorderGroups &&
        !(reorderId in reorderGroups[reorderGroup])
      ) {
        throw new Error(
          `Unknown reorderId: ${reorderId} in reorderGroup: ${reorderGroup}`,
        );
      }

      delete reorderGroups[reorderGroup][reorderId];
    } else {
      if (!(reorderId in reorderComponents)) {
        throw new Error(`Unknown reorderId: ${reorderId}`);
      }

      delete reorderComponents[reorderId];
    }
  }

  function startDrag(reorderId, reorderGroup, index, element, component) {
    target = component;

    clearInterval(scrollInterval);
    scrollInterval = setInterval(autoScroll, CONSTANTS.SCROLL_INTERVAL);

    validateComponentIdAndGroup(reorderId, reorderGroup);

    draggedIndex = index;
    placedIndex = index;
    draggedStyle = null;
    draggedElement = element;

    draggedId = reorderId;
    placedId = reorderId;
    activeGroup = null;

    if (typeof reorderGroup !== 'undefined') {
      activeGroup = reorderGroup;

      triggerGroup();
    } else if (draggedId !== null && reorderId === draggedId) {
      trigger();
    }
  }

  function stopDrag(reorderId, reorderGroup) {
    target = null;

    clearInterval(scrollInterval);

    validateComponentIdAndGroup(reorderId, reorderGroup);

    if (activeGroup !== null) {
      if (reorderGroup === activeGroup) {
        draggedIndex = -1;
        placedIndex = -1;
        draggedStyle = null;
        draggedElement = null;

        // These need to be cleared after trigger to allow state updates to these components
        triggerGroup(['activeGroup']);

        draggedId = null;
        placedId = null;
        activeGroup = null;
      }
    } else if (draggedId !== null && reorderId === draggedId) {
      draggedIndex = -1;
      placedIndex = -1;
      draggedStyle = null;
      draggedElement = null;

      // These need to be cleared after trigger to allow state updates to these components
      trigger(['activeGroup']);

      draggedId = null;
      placedId = null;
      activeGroup = null;
    }
  }

  function setPlacedIndex(reorderId, reorderGroup, index, component) {
    target = component;

    validateComponentIdAndGroup(reorderId, reorderGroup);

    if (typeof reorderGroup !== 'undefined') {
      if (reorderGroup === activeGroup) {
        placedId = reorderId;
        placedIndex = index;

        triggerGroup();
      }
    } else if (draggedId !== null && reorderId === draggedId) {
      placedIndex = index;

      trigger();
    }
  }

  function setDraggedStyle(reorderId, reorderGroup, style) {
    validateComponentIdAndGroup(reorderId, reorderGroup);

    if (typeof reorderGroup !== 'undefined') {
      if (reorderGroup === activeGroup) {
        draggedStyle = style;

        triggerGroup();
      }
    } else if (draggedId !== null && reorderId === draggedId) {
      draggedStyle = style;

      trigger();
    }
  }

  this.getState = getState;
  this.registerReorderComponent = registerReorderComponent;
  this.unregisterReorderComponent = unregisterReorderComponent;
  this.startDrag = startDrag;
  this.stopDrag = stopDrag;
  this.setPlacedIndex = setPlacedIndex;
  this.setDraggedStyle = setDraggedStyle;
}

const store = new Store();

function reorder(list, previousIndex, nextIndex) {
  const copy = [].concat(list);
  const item = copy.splice(previousIndex, 1)[0];

  copy.splice(nextIndex, 0, item);

  return copy;
}

function reorderImmutable(list, previousIndex, nextIndex) {
  const item = list.get(previousIndex);
  return list.delete(previousIndex).splice(nextIndex, 0, item);
}

function reorderFromTo(lists, previousIndex, nextIndex) {
  const previousList = [].concat(lists.from);
  const nextList = [].concat(lists.to);

  const item = previousList.splice(previousIndex, 1)[0];
  nextList.splice(nextIndex, 0, item);

  return {
    from: previousList,
    to: nextList,
  };
}

function reorderFromToImmutable(lists, previousIndex, nextIndex) {
  const item = lists.from.get(previousIndex);

  return {
    from: lists.from.delete(previousIndex),
    to: lists.to.splice(nextIndex, 0, item),
  };
}

function withReorderMethods(Reorder) {
  Reorder.reorder = reorder;
  Reorder.reorderImmutable = reorderImmutable;
  Reorder.reorderFromTo = reorderFromTo;
  Reorder.reorderFromToImmutable = reorderFromToImmutable;
  return Reorder;
}

function assign() {
  const arguments_ = Array.prototype.slice.call(arguments);

  if (!arguments_.length) {
    return undefined;
  }

  if (arguments_.length === 1) {
    return arguments_[0];
  }

  const object = arguments_.shift();

  while (arguments_.length) {
    const argument = arguments_.shift();

    for (const key in argument) {
      object[key] = argument[key];
    }
  }

  return object;
}

function getReorderComponent(React, ReactDOM, createReactClass, PropertyTypes) {
  const Reorder = createReactClass({
    displayName: 'Reorder',

    getInitialState() {
      return store.getState();
    },

    isDragging() {
      return this.state.draggedIndex >= 0;
    },

    isPlacing() {
      return this.state.placedIndex >= 0;
    },

    isDraggingFrom() {
      return this.props.reorderId === this.state.draggedId;
    },

    isPlacingTo() {
      return this.props.reorderId === this.state.placedId;
    },

    isInvolvedInDragging() {
      return (
        this.props.reorderId === this.state.draggedId ||
        this.props.reorderGroup === this.state.activeGroup
      );
    },

    preventContextMenu(event) {
      if (downPos && this.props.disableContextMenus) {
        event.preventDefault();
      }
    },

    preventNativeScrolling(event) {
      event.preventDefault();
    },

    persistEvent(event) {
      if (typeof event.persist === 'function') {
        event.persist();
      }
    },

    copyTouchKeys(event) {
      if (event.touches && event.touches[0]) {
        this.persistEvent(event);

        event.clientX = event.touches[0].clientX;
        event.clientY = event.touches[0].clientY;
      }
    },

    xCollision(event, rect) {
      return event.clientX >= rect.left && event.clientX <= rect.right;
    },

    yCollision(event, rect) {
      return event.clientY >= rect.top && event.clientY <= rect.bottom;
    },

    findCollisionIndex(event, listElements) {
      for (const [index, listElement] of listElements.entries()) {
        if (!listElement.dataset.placeholder && !listElement.dataset.dragged) {
          const rect = listElement.getBoundingClientRect();

          switch (this.props.lock) {
            case 'horizontal':
              if (this.yCollision(event, rect)) {
                return index;
              }
              break;
            case 'vertical':
              if (this.xCollision(event, rect)) {
                return index;
              }
              break;
            default:
              if (
                this.yCollision(event, rect) &&
                this.xCollision(event, rect)
              ) {
                return index;
              }
              break;
          }
        }
      }

      return -1;
    },

    collidesWithElement(event, element) {
      const rect = element.getBoundingClientRect();
      return this.yCollision(event, rect) && this.xCollision(event, rect);
    },

    getHoldTime(event) {
      if (event.touches && typeof this.props.touchHoldTime !== 'undefined') {
        return Number.parseInt(this.props.touchHoldTime, 10) || 0;
      }
      if (typeof this.props.mouseHoldTime !== 'undefined') {
        return Number.parseInt(this.props.mouseHoldTime, 10) || 0;
      }

      return Number.parseInt(this.props.holdTime, 10) || 0;
    },

    startDrag(event, target, index) {
      if (!this.moved) {
        const rect = target.getBoundingClientRect();

        const draggedStyle = {
          position: 'fixed',
          top: rect.top,
          left: rect.left,
          width: rect.width,
          height: rect.height,
        };

        store.startDrag(
          this.props.reorderId,
          this.props.reorderGroup,
          index,
          this.props.children[index],
          this,
        );
        store.setDraggedStyle(
          this.props.reorderId,
          this.props.reorderGroup,
          draggedStyle,
        );

        mouseOffset = {
          clientX: event.clientX,
          clientY: event.clientY,
        };

        mouseDown = {
          clientX: event.clientX,
          clientY: event.clientY,
        };
      }
    },

    // Begin dragging index, set initial drag style, set placeholder position, calculate mouse offset
    onItemDown(callback, index, event) {
      if (typeof callback === 'function') {
        callback(event);
      }

      if (event.button === 2 || this.props.disabled) {
        return;
      }

      this.copyTouchKeys(event);

      this.moved = false;
      downPos = {
        clientX: event.clientX,
        clientY: event.clientY,
      };

      const holdTime = this.getHoldTime(event);
      const target = event.currentTarget;

      if (holdTime) {
        this.persistEvent(event);
        this.holdTimeout = setTimeout(
          this.startDrag.bind(this, event, target, index),
          holdTime,
        );
      } else {
        this.startDrag(event, target, index);
      }
    },

    // Stop dragging - reset style & draggedIndex, handle reorder
    onWindowUp(event) {
      clearTimeout(this.holdTimeout);

      if (this.isDragging() && this.isDraggingFrom()) {
        const fromIndex = this.state.draggedIndex;
        const toIndex = this.state.placedIndex;

        store.stopDrag(this.props.reorderId, this.props.reorderGroup);

        if (
          fromIndex >= 0 &&
          (fromIndex !== toIndex ||
            this.state.draggedId !== this.state.placedId) &&
          typeof this.props.onReorder === 'function'
        ) {
          this.props.onReorder(
            event,
            fromIndex,
            toIndex -
              (this.state.draggedId === this.state.placedId &&
              fromIndex < toIndex
                ? 1
                : 0),
            this.state.draggedId,
            this.state.placedId,
          );
        }
      }

      downPos = null;
      mouseOffset = null;
      mouseDown = null;
    },

    // Update dragged position & placeholder index, invalidate drag if moved
    onWindowMove(event) {
      this.copyTouchKeys(event);

      if (
        downPos &&
        (Math.abs(event.clientX - downPos.clientX) >=
          CONSTANTS.HOLD_THRESHOLD ||
          Math.abs(event.clientY - downPos.clientY) >= CONSTANTS.HOLD_THRESHOLD)
      ) {
        this.moved = true;
      }

      if (this.isDragging() && this.isInvolvedInDragging()) {
        this.preventNativeScrolling(event);

        const element = this.rootNode;

        if (this.collidesWithElement(event, element)) {
          const children = element.childNodes;
          const collisionIndex = this.findCollisionIndex(event, children);

          if (
            collisionIndex <= this.props.children.length &&
            collisionIndex >= 0
          ) {
            store.setPlacedIndex(
              this.props.reorderId,
              this.props.reorderGroup,
              collisionIndex,
              this,
            );
          } else if (
            typeof this.props.reorderGroup !== 'undefined' && // Is part of a group
            (!this.props.children ||
              !this.props.children.length || // If all items removed
              (this.isDraggingFrom() && this.props.children.length === 1)) // If dragging back to a now empty list
          ) {
            store.setPlacedIndex(
              this.props.reorderId,
              this.props.reorderGroup,
              0,
              this,
            );
          }
        }

        this.state.draggedStyle.transform = createOffsetStyles(
          event,
          this.props,
        );
        store.setDraggedStyle(
          this.props.reorderId,
          this.props.reorderGroup,
          this.state.draggedStyle,
        );

        mouseOffset = {
          clientX: event.clientX,
          clientY: event.clientY,
        };
      }
    },

    setDragState(state) {
      const isPartOfGroup = this.props.reorderGroup;
      const isGroupDragged = state.activeGroup;
      const storedActiveGroup = this.state.activeGroup;

      const wasGroupDragged = !isGroupDragged && storedActiveGroup;

      const isActiveGroup =
        isPartOfGroup &&
        isGroupDragged &&
        state.activeGroup === this.props.reorderGroup;

      const isDragged = this.props.reorderId === state.draggedId;
      const isPlaced = this.props.reorderId === state.placedId;
      const wasPlaced = this.props.reorderId === this.state.placedId;

      // This check is like a shouldComponentUpdate but specific to our store state
      // Allowing prop changes to update the component
      if (
        (!isGroupDragged && !isPartOfGroup && (isDragged || isPlaced)) ||
        (isPartOfGroup && (!storedActiveGroup || wasGroupDragged)) ||
        wasGroupDragged ||
        (isActiveGroup && (isDragged || isPlaced || wasPlaced))
      ) {
        this.setState(state);
      }
    },

    // Add listeners and store root node
    componentDidMount() {
      store.registerReorderComponent(this);
      window.addEventListener('mouseup', this.onWindowUp, { passive: false });
      window.addEventListener('touchend', this.onWindowUp, {
        passive: false,
      });
      window.addEventListener('mousemove', this.onWindowMove, {
        passive: false,
      });
      window.addEventListener('touchmove', this.onWindowMove, {
        passive: false,
      });
      window.addEventListener('contextmenu', this.preventContextMenu, {
        passive: false,
      });
      this.storeRootNode();
    },

    // Remove listeners
    componentWillUnmount() {
      store.unregisterReorderComponent(this);
      clearTimeout(this.holdTimeout);

      window.removeEventListener('mouseup', this.onWindowUp);
      window.removeEventListener('touchend', this.onWindowUp);
      window.removeEventListener('mousemove', this.onWindowMove);
      window.removeEventListener('touchmove', this.onWindowMove);
      window.removeEventListener('contextmenu', this.preventContextMenu);
    },

    storeRootNode() {
      const element = window.document.getElementById('TemplateBuilderV2Id');
      this.rootNode = element;

      if (typeof this.props.getRef === 'function') {
        this.props.getRef(element);
      }
    },

    render() {
      const children =
        this.props.children &&
        this.props.children.map((child, index) => {
          const isDragged =
            this.isDragging() &&
            this.isDraggingFrom() &&
            index === this.state.draggedIndex;

          const draggedStyle = isDragged
            ? assign({}, child.props.style, this.state.draggedStyle)
            : child.props.style;

          const draggedClass = [
            child.props.className || '',
            isDragged ? this.props.draggedClassName : '',
          ].join(' ');

          return React.cloneElement(
            isDragged ? this.state.draggedElement : child,
            {
              style: draggedStyle,
              className: draggedClass,
              onMouseDown: this.onItemDown.bind(
                this,
                child.props.onMouseDown,
                index,
              ),
              onTouchStart: this.onItemDown.bind(
                this,
                child.props.onTouchStart,
                index,
              ),
              'data-dragged': isDragged ? true : null,
            },
          );
        });

      const placeholderElement =
        this.props.placeholder || this.state.draggedElement;

      if (this.isPlacing() && this.isPlacingTo() && placeholderElement) {
        const placeholder = React.cloneElement(placeholderElement, {
          key: 'react-reorder-placeholder',
          className: [
            placeholderElement.props.className || '',
            this.props.placeholderClassName,
          ].join(' '),
          'data-placeholder': true,
        });

        children.splice(this.state.placedIndex, 0, placeholder);
      }

      return React.createElement(
        this.props.component,
        {
          className: this.props.className,
          id: this.props.id,
          style: this.props.style,
          onClick: this.props.onClick,
        },
        children,
      );
    },
  });

  // Reorder.propTypes = {
  //   component: PropertyTypes.oneOfType([
  //     PropertyTypes.func,
  //     PropertyTypes.string,
  //   ]),
  //   getRef: PropertyTypes.func,
  //   reorderId: PropertyTypes.string,
  //   reorderGroup: PropertyTypes.string,
  //   placeholderClassName: PropertyTypes.string,
  //   draggedClassName: PropertyTypes.string,
  //   lock: PropertyTypes.string,
  //   holdTime: PropertyTypes.number,
  //   touchHoldTime: PropertyTypes.number,
  //   mouseHoldTime: PropertyTypes.number,
  //   onReorder: PropertyTypes.func,
  //   placeholder: PropertyTypes.element,
  //   autoScroll: PropertyTypes.bool,
  //   autoScrollParents: PropertyTypes.bool,
  //   disabled: PropertyTypes.bool,
  //   disableContextMenus: PropertyTypes.bool,
  // };

  Reorder.defaultProps = {
    component: 'div',
    // getRef: function,
    // reorderId: id,
    // reorderGroup: group,
    placeholderClassName: 'placeholder',
    draggedClassName: 'dragged',
    // lock: direction,
    holdTime: 0,
    // touchHoldTime: 0,
    // mouseHoldTime: 0,
    // onReorder: function,
    // placeholder: react element
    autoScroll: true,
    autoScrollParents: true,
    disabled: false,
    disableContextMenus: true,
  };

  return Reorder;
}

export default withReorderMethods(
  getReorderComponent(React, ReactDom, createReactClass),
);
